import CheckoutOverlay from '../../../../../v2/components/CheckoutOverlay/CheckoutOverlay';
import ZippayOverlayLazyLoader from './ZippayOverlay/ZippayOverlayLazyLoader';

export function ZippayOverlay() {
  return (
    <CheckoutOverlay
      popup
      nopadding
      stickyHeader
      fullscreenMobile
    >
      <ZippayOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

ZippayOverlay.propTypes = {};

export default ZippayOverlay;
